import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";

const Blog8 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/31d60824-71d1-44bc-5c4c-752792f68400/public" //Init_Blog8.webp
                alt="Img"
                loading="lazy"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <h1
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                <span className="font-semibold">
                  GenAI for SMBs: Practical Use{" "}
                  <br className="hidden md:block" /> Cases Beyond ChatGPT in
                  2025
                </span>
              </h1>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            The term "generative AI" (GenAI) is no longer just a catchphrase
            used by big businesses. Beyond the standard use of ChatGPT, small
            and medium businesses (SMBs) are utilising AI in creative ways in
            2025. GenAI is changing how SMBs compete in a digital-first economy,
            from customer service to marketing automation.
          </p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p className="font-bold">Practical Use Cases for SMBs</p>

            <p>
              • AI-Powered Marketing Automation: Personalised email campaigns,
              social media posts, and content production are all automated.
            </p>

            <p>
              • Customer support bots are sophisticated chatbots driven by GenAI
              that provide multilingual, real-time customer service.
            </p>

            <p>
              • Product Design Assistance: Create mockups, prototypes, and
              design variations in a matter of minutes with AI tools.
            </p>

            <p>
              • AI in HR and recruitment aids in interview scheduling, resume
              screening, and even cultural fit prediction.
            </p>

            <p>
              • Sales Enablement: AI technologies examine consumer behaviour to
              make product recommendations and expedite transaction completion.
            </p>
          </div>

          <div className="space-y-3">
            <p className="font-bold">Challenges for SMBs</p>

            <p>1. Data privacy concerns</p>

            <p>2. Cost vs ROI considerations</p>

            <p>3. Staff training and adoption</p>
          </div>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <p>
            GenAI is democratizing innovation for SMBs. With the right tools,
            small businesses can punch far above their weight, outpacing
            competitors and future-proofing operations.
          </p>
          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>September 19, 2025 ∙ 5 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog8;
